const defaultEditServiceState = () => ({
  serviceInEditing: {
    edited: false,
    description: null,
    price: null,
    discount: 0,
    discountType: 0,
    totalPrice: null,
  },
});

export const initialState = {
  ...defaultEditServiceState(),
  modalEditServiceIsOpen: false,
  modalCancelNfseIsOpen: false,
  modalFiscalValidationIsOpen: false,
};

export default {
  ...initialState,
};
